import ModalAddToStock from "../modals/ModalAddToStock";
import ModalEditFromStock from "../modals/ModalEditFromStock";

import ModalTransDetails from "../modals/ModalTransDetails";
import ModalEditTransFactorNum from "../modals/ModalEditTransFactorNum";
import ModalRejectFactor from "../modals/ModalRejectFactor";

const ImportModals = () => {
    return (
        <div id={'base-box-all-modals'}>
            <ModalAddToStock />
            <ModalEditFromStock />
            
            <ModalTransDetails />
            <ModalEditTransFactorNum />
            <ModalRejectFactor />
        </div>
    );
}

export default ImportModals;
